import React,{Component} from "react";
import Header from "../components/Header";


class Listings extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
   properties:[],
   isLoaded:false,
    };
  }
//https://api.test.takengo.risee.in/index.php/rest/items/get/api_key/1fWwZNrzUiOW2pWEffgy3fXS1R7khL/id/itm_f90d921abee06a6a355afb4958cb9187/limit/2/

componentDidMount(){
fetch("https://api.test.takengo.risee.in/index.php/rest/items/get/api_key/1fWwZNrzUiOW2pWEffgy3fXS1R7khL/limit/10/")
.then(response => response.json())
.then(data =>	this.setState({ isLoaded:true, properties:data,  }))
.catch(error => console.log(error));
};
    render(){
      var {properties, isLoaded} = this.state;
        return(
            <div>

                  {/*<!-- Header Container -->*/}
                  <Header listings="current"/>
                  {/*<!-- Header Container / End -->*/}

                 {/*<!-- Titlebar -->*/}
                 <div className="parallax titlebar" style={{backgroundImage:"url(assets/images/home-parallax-3.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1160.24px", backgroundPosition:"50% -550.067px"}}>
                   <div className="parallax-overlay" style={{backgroundColor:"rgb(48, 48, 48)", opacity: "0.8"}}></div>
                   <div id="titlebar">
                     <div className="container">
                       <div className="row">
                         <div className="col-md-12">
                           <h2>Listings Grid Compact</h2>
                           {/*<!-- Breadcrumbs -->*/}
                           <nav id="breadcrumbs">
                             <ul>
                               <li><a href="index.html">Home</a></li>
                               <li>Listings Grid Compact</li>
                             </ul>
                           </nav>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                 
                 {/*<!-- Main Search Container -->*/}
                   <div className="utf-main-search-container-area inner-map-search-block inner-search-item">
                     <div className="container">
                       <div className="row">
                         <div className="col-md-12">             
                           <form className="utf-main-search-form-item">              
                             {/*<!-- Type -->*/}
                             <div className="utf-search-type-block-area margin-top-35">
               				<div className="search-type">
               				  <label className="active">
               					<input className="first-tab" name="tab" checked="checked" type="radio"/>Buy</label>
               				  <label>
               					<input name="tab" type="radio"/>Rent</label>
               				  <label>
               					<input name="tab" type="radio"/>Sale</label>
               					<div className="utf-search-type-arrow"></div>
               				</div>
               			  </div>
                             
                             {/*<!-- Box -->*/}
                             <div className="utf-main-search-box-area"> 
                               {/*<!-- Row With Forms -->*/}
                               <div className="row with-forms"> 
                                 {/*<!-- Status -->*/}
                                 <div className="col-md-2 col-sm-4">
                                     <select data-placeholder="Select City" title="Select City" className="utf-chosen-select-single-item">
               						<option>Select City</option>
               						<option>Afghanistan</option>
               						<option>Albania</option>
               						<option>Algeria</option>
               						<option>Brazil</option>
               						<option>Burundi</option>
               						<option>Bulgaria</option>
               						<option>California</option>
               						<option>Germany</option>
               						<option>Grenada</option>
               						<option>Guatemala</option>
               						<option>Iceland</option>                        
               					  </select>
                                 </div>
                                 
                                 {/*<!-- Property Type -->*/}
                                 <div className="col-md-2 col-sm-4">
                                   <select data-placeholder="Property Type" className="utf-chosen-select-single-item">
               					  <option>Property Type</option>
               					  <option>Residential</option>
               					  <option>Apartments</option>
               					  <option>Houses</option>
               					  <option>Commercial</option>
               					  <option>Land</option>
               					</select>
                                 </div>
               				  
               				  {/*<!-- Status -->*/}
                                 <div className="col-md-2 col-sm-4">
                                   <select data-placeholder="Any Status" className="utf-chosen-select-single-item">
               					  <option>Any Status</option>
               					  <option>For Sale</option>
               					  <option>For Rent</option>
               					</select>
                                 </div>
                                 
                                 {/*<!-- Main Search Input -->*/}
                                 <div className="col-md-6">
                                   <div className="utf-main-search-input-item">
                                     <input type="text" placeholder="Enter Keywords..." value=""/>
                                     <button className="button"><i className="fa fa-search"></i> Search</button>
                                   </div>
                                 </div>
                               </div>
                               {/*<!-- Row With Forms / End -->*/}                                
                             </div>              
                           </form>            
                         </div>
                       </div>
                     </div>
                   </div>
                 {/*<!-- Main Search Container / End -->*/}
                 
                 {/*<!-- Content -->*/}
                 <div className="container">
                   <div className="row sticky-wrapper">
                     <div className="col-md-8"> 
                       {/*<!-- Sorting -->*/}
                       <div className="utf-sort-box-aera">
                           <div className="sort-by">
                             <label>Sort By:</label>
                             <div className="sort-by-select">
                               <select data-placeholder="Default Properties" className="utf-chosen-select-single-item" >
                                 <option>Default Properties</option>
                                 <option>Low to High Price</option>
                                 <option>High to Low Price</option>
                                 <option>Newest Properties</option>
                                 <option>Oldest Properties</option>
                               </select>
                             </div>
                           </div>
                       </div>
                       
                       {/*<!-- Listings Container -->*/}
                       <div className="row"> 

                       {isLoaded ? properties.map(properties => (
                           ///*<!-- Listing Item -->*/
                           <div className="col-md-6">
                           <div className="utf-listing-item compact"> 
                               <a href="single-property-page-2.html" className="utf-smt-listing-img-container">
                                 <div className="utf-listing-badges-item"> <span className="featured">Featured</span> <span className="for-sale">For {properties.item_type_id == 4 ? 'Sale' : null}</span> </div>
                                 <div className="utf-listing-img-content-item"> 
                                  <span className="utf-listing-compact-title-item">{properties.title} <i>$ {properties.price}</i></span>
                                 </div>
                                 <img src={properties.default_photo.img_path == '' ? "assets/images/listing-02.jpg" : "https://api.test.takengo.risee.in/uploads/"+properties.default_photo.img_path } alt="" style={{height:"260px"}} /> 
                                 <ul className="listing-hidden-content">
                                     {properties.numberofbedrooms == '' || properties.numberofbedrooms == 0  ? '' : <li style={{padding:"10px"}}><i className="fa fa-bed"></i> Beds <span>{properties.numberofbedrooms}</span></li>}
		     			                       {properties.numberofbathrooms == '' || properties.numberofbathrooms == 0 ? '' : <li style={{padding:"10px"}}><i className="icon-feather-codepen"></i> Baths <span>{properties.numberofbathrooms}</span></li>}
		     					    		           {properties.car_parking == '' || properties.car_parking == 0 ? '' : <li style={{padding:"10px"}}><i className="fa fa-car"></i> Parking <span>{properties.car_parking}</span></li>}
		     					    		           {properties.area == '' || properties.area == 0 ? '' : <li style={{padding:"10px"}}><i className ="fa fa-arrows-alt"></i> {properties.area_type} <span>{properties.area}</span></li>}			
                                 </ul>
                               </a> 
                            </div>
                         </div>
                         ///*<!-- Listing Item / End -->*/
                       )) : <h2 className="text-center py-5">Loading...</h2> } 


                      </div>
                       
                       {/*<!-- Pagination -->*/}
                       <div className="clearfix"></div>
                       <div className="utf-pagination-container margin-top-20">
                         <nav className="pagination">
                           <ul>
                             <li><a href="#"><i className="fa fa-angle-left"></i></a></li>
               			  <li><a href="#" className="current-page">1</a></li>
                             <li><a href="#">2</a></li>
                             <li><a href="#">3</a></li>
                             <li className="blank">...</li>
                             <li><a href="#">10</a></li>
               			  <li><a href="#"><i className="fa fa-angle-right"></i></a></li>
                           </ul>
                         </nav>          
                       </div>
                       {/*<!-- Pagination / End -->*/}         
                     </div>
                     
                     {/*<!-- Sidebar -->*/}
                     <div className="col-md-4">
                       <div className="sidebar"> 
               		  {/*<!-- Widget -->*/}
                           <div className="widget utf-sidebar-widget-item">
               			  <div className="utf-detail-banner-add-section">
               				 <a href="#"><img src="assets/images/banner-add-2.jpg" alt="banner-add-2"/></a>
               			  </div>             
                           </div>
                         {/*<!-- Widget / End-->*/}
               		  
                         {/*<!-- Widget -->*/}
               		  <div className="widget utf-sidebar-widget-item">
                           <div className="utf-boxed-list-headline-item">
               				<h3>Find New Home</h3>
               			</div>
               			<div className="row with-forms"> 
                             <div className="col-md-6 col-sm-6 col-xs-6">
                               <select data-placeholder="Any Status" className="utf-chosen-select-single-item">
                                 <option>Any Status</option>
                                 <option>For Sale</option>
                                 <option>For Rent</option>
                               </select>
                             </div>
               			  <div className="col-md-6 col-sm-6 col-xs-6">
                               <select data-placeholder="Any Type" className="utf-chosen-select-single-item">
                                 <option>Any Type</option>
                                 <option>Apartments</option>
                                 <option>Houses</option>
                                 <option>Commercial</option>
                                 <option>Garages</option>
                                 <option>Lots</option>
                               </select>
                             </div>
                           </div>
                           {/*<!-- Row / End -->*/} 
                           
               			{/*<!-- Row -->*/}
                           <div className="row with-forms"> 
                             <div className="col-md-6">
                               <select data-placeholder="Beds" className="utf-chosen-select-single-item">
                                 <option label="blank"></option>
                                 <option>Beds (Any)</option>
                                 <option>1</option>
                                 <option>2</option>
                                 <option>3</option>
                                 <option>4</option>
                                 <option>5</option>
                               </select>
                             </div>
                             
                             <div className="col-md-6">
                               <select data-placeholder="Baths" className="utf-chosen-select-single-item">
                                 <option label="blank"></option>
                                 <option>Baths (Any)</option>
                                 <option>1</option>
                                 <option>2</option>
                                 <option>3</option>
                                 <option>4</option>
                                 <option>5</option>
                               </select>
                             </div>
                           </div>
                           {/*<!-- Row / End -->*/}
               			
                           {/*<!-- Row -->*/}
                           <div className="row with-forms"> 
                             <div className="col-md-12">
                               <select data-placeholder="All States" className="chosen-select">
                                 <option>All States</option>
                                 <option>Alabama</option>
                                 <option>Alaska</option>
                                 <option>Arizona</option>
                                 <option>Arkansas</option>
                                 <option>California</option>
                                 <option>Colorado</option>
                                 <option>Connecticut</option>
                                 <option>Delaware</option>
                                 <option>Florida</option>
                                 <option>Georgia</option>                                    
                               </select>
                             </div>
                           </div>
                           {/*<!-- Row / End -->*/} 
                           
                           {/*<!-- Row -->*/}
                           <div className="row with-forms"> 
                             <div className="col-md-12">
                               <select data-placeholder="All Cities" className="chosen-select">
                                 <option>All Cities</option>
                                 <option>New York</option>
                                 <option>Los Angeles</option>
                                 <option>Chicago</option>
                                 <option>Brooklyn</option>
                                 <option>Queens</option>
                                 <option>Houston</option>
                                 <option>Manhattan</option>                  
                               </select>
                             </div>
                           </div>
                           {/*<!-- Row / End -->*/} 
                           
                           {/*<!-- Area Range -->*/}
                           <div className="utf-range-slider-item margin-top-10 margin-bottom-25">
                             <label>Area Range</label>
                             <div id="utf-area-range-item" data-min="0" data-max="1500" data-unit="sq ft"></div>
                             <div className="clearfix"></div>
                           </div>
                           
                           {/*<!-- Price Range -->*/}
                           <div className="utf-range-slider-item margin-bottom-10">
                             <label>Price Range</label>
                             <div id="utf-price-range-item" data-min="0" data-max="400000" data-unit="$"></div>
                             <div className="clearfix"></div>
                           </div>
                           
                           {/*<!-- More Search Options -->*/} 
                           <a href="#" className="utf-utf-more-search-options-area-button margin-bottom-10 margin-top-20" data-open-title="More Search Option" data-close-title="Less Search Option"></a>
                           <div className="utf-more-search-options-area relative"> 
                             <div className="checkboxes one-in-row margin-bottom-10">
                               <input id="check-2" type="checkbox" name="check"/>
                               <label for="check-2">Air Conditioning</label>
                               <input id="check-3" type="checkbox" name="check"/>
                               <label for="check-3">Swimming Pool</label>
                               <input id="check-4" type="checkbox" name="check" />
                               <label for="check-4">Central Heating</label>
                               <input id="check-5" type="checkbox" name="check"/>
                               <label for="check-5">Laundry Room</label>
                               <input id="check-6" type="checkbox" name="check"/>
                               <label for="check-6">Gym</label>
                               <input id="check-7" type="checkbox" name="check"/>
                               <label for="check-7">Alarm</label>
                               <input id="check-8" type="checkbox" name="check"/>
                               <label for="check-8">Window Covering</label>
                             </div>
                             {/*<!-- Checkboxes / End -->*/}               
                           </div>
                           {/*<!-- More Search Options / End -->*/}
                           <button className="button fullwidth margin-top-10">Search</button>
                         </div>
                         {/*<!-- Widget / End -->*/}
               			
               		  {/*<!-- Widget -->*/}
                           <div className="widget utf-sidebar-widget-item">
               			  <div className="utf-boxed-list-headline-item">
               				  <h3>Recently Viewed</h3>
               			  </div>
                             <ul className="widget-tabs">
                               {/*<!-- Post #1 -->*/}
                               <li>
                                 <div className="widget-content">
                                   <div className="widget-thumb"> <a href="blog-full-width-single-post.html"><img src="assets/images/blog-widget-03.jpg" alt=""/></a> </div>
                                   <div className="widget-text">
                                     <h5><a href="blog-full-width-single-post.html">How to Woo a Recruiter and Land Your Dream.</a></h5>
                                     <span>$22,000/mo</span> 
               					</div>
                                   <div className="clearfix"></div>
                                 </div>
                               </li>
                               
                               {/*<!-- Post #2 -->*/}
                               <li>
                                 <div className="widget-content">
                                   <div className="widget-thumb"> <a href="blog-full-width-single-post.html"><img src="assets/images/blog-widget-02.jpg" alt=""/></a> </div>
                                   <div className="widget-text">
                                     <h5><a href="blog-full-width-single-post.html">Hey Its Time To Get Up And Get Hired.</a></h5>
                                     <span>$22,000/mo</span> 
               					</div>
                                   <div className="clearfix"></div>
                                 </div>
                               </li>
                               
                               {/*<!-- Post #3 -->*/}
                               <li>
                                 <div className="widget-content">
                                   <div className="widget-thumb"> <a href="blog-full-width-single-post.html"><img src="assets/images/blog-widget-01.jpg" alt=""/></a> </div>
                                   <div className="widget-text">
                                     <h5><a href="blog-full-width-single-post.html">The Best Canadian Merchant Account Providers.</a></h5>
                                     <span>$22,000/mo</span> 
               					</div>
                                   <div className="clearfix"></div>
                                 </div>
                               </li>
                             </ul>
                           </div>
                           {/*<!-- Widget / End-->*/} 
                           
               			{/*<!-- Widget -->*/}
                           <div className="widget utf-sidebar-widget-item">
               			  <div className="utf-boxed-list-headline-item">
               				  <h3>Property Categorie</h3>
               				  <div className="utf-sidebar-categorie"> 
               					<ul>
               					  <li><a href="#">Apartment</a><span>10 Property</span></li> 
               					  <li><a href="#">Condo</a><span>14 Property</span></li> 
               					  <li><a href="#">Family House</a><span>18 Property</span></li> 
               					  <li><a href="#">Modern Villa</a><span>12 Property</span></li> 
               					  <li><a href="#">Town House</a><span>10 Property</span></li> 					  
               					</ul>
               				  </div>
               			  </div>              
                           </div>
                           {/*<!-- Widget / End-->*/}
                         <div className="clearfix"></div>	
                       </div>
                     </div>
                     {/*<!-- Sidebar / End -->*/} 
                   </div>
                 </div>

                 <div style={{paddingTop:"15px", paddingBottom:"15px",}}></div>
            </div>
        )
    }
}

export default Listings;